<template>
  <connexion-container :session-type="sessionType" :no-client="true">
    <notification>
      <router-link :to="{ name: `${sessionType}SignIn` }">Retourner à la page de connexion</router-link>
    </notification>
    <h1 class="h4 mb-4 d-none d-md-block">Réinitialisation du mot de passe</h1>
    <vv-observer tag="form" v-slot="{ invalid }" class="access-form__form pt-3" @submit.prevent="submit">
      <h1 class="h4 mb-4 d-block d-md-none">Réinitialisation du mot de passe</h1>
      <r-input v-model="params.password"
        name="mot de passe"
        label="Nouveau mot de passe"
        icon="key"
        :type="password"
        placeholder="Min. 8 caractères"
        :disabled= "disabled"
        :rules="'min:8'"
        :error="error.password">
        <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('password')"></i>
      </r-input>
      <r-input v-model="params.password_confirmation"
        name="mot de passe"
        label="Confirmation du nouveau mot de passe"
        icon="key"
        :type="passwordConfirmation"
        placeholder="Min. 8 caractères"
        :disabled= "disabled"
        :rules="'min:8'"
        :error="error.password_confirmation">
        <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('passwordConfirmation')"></i>
      </r-input>
      <s-button :css-class="'btn-block access-form__btns mb-0 btn-' + $mainColor" :disabled="invalid" :loading="loading" @submit="submit">
        Sauvegarder le nouveau mot de passe
      </s-button>
    </vv-observer>
  </connexion-container>
</template>

<script>
import ConnexionContainer from '@/components/layout/ConnexionContainer'

export default {
  name: 'ResetPasswordForm',
  components: {
    ConnexionContainer
  },
  props: {
    sessionType: String
  },
  data () {
    return {
      loading: false,
      auth: {},
      params: {},
      error: {},
      password: 'password',
      passwordConfirmation: 'password',
      disabled: false
    }
  },
  created () {
    this.auth = this.$route.query
    if (_.isEmpty(this.auth.reset_password)) {
      this.disabled = true
      this.$store.dispatch('setNotification', {
        message: 'Le lien n\'est plus valide.',
        mode: 'danger',
        expiration: 0
      })
    }
  },
  methods: {
    submit () {
      this.loading = true
      this.$http.put(`/${this.auth.config}_auth/password`, this.params, {
        headers: this.auth
      }).then(resp => {
        this.$router.push({ name: `${this.auth.config}SignIn`, params: { notification: resp.data.message } })
      }).catch(err => {
        this.loading = false
        if (err.response.status === 422) {
          let e = err.response.data.errors
          this.error = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
    },
    switchType (type) {
      this[type] = this[type] === 'password' ? 'text' : 'password'
    }
  }
}
</script>
